module.exports = __webpack_public_path__ + "img/home--offer--online-in-person.b5715318.svg";